module.exports = __webpack_public_path__ + "static/media/pl_logo.1e9db352.png";